<script>
import Vue from 'vue';
import store from '@/store';
import i18n from '@/services/i18n';
import globalCss from '!!raw-loader!sass-loader!@/assets/css/checkout/global.scss';
import nunito from '!!raw-loader!@/assets/fonts/nunito.css';

export default {
  name: 'EmbedIframe',
  props: {
    title: { type: String, required: true },
    css: { type: String, default: '' },
    height: { type: String, default: '278px' },
    autoHeight: Boolean
  },
  render(h) {
    return h('iframe', {
      on: { load: this.renderChildren },
      attrs: { src: 'about:blank', title: this.title, frameborder: 0 },
      style: { display: 'block', width: '100%', height: this.height, maxWidth: '1200px', border: 'none' }
    });
  },
  methods: {
    renderChildren() {
      this.cleanup();
      const doc = this.$el.contentDocument;
      const style = doc.createElement('style');
      style.textContent = globalCss + nunito + this.css;
      doc.head.appendChild(style);
      const el = doc.createElement('div');
      doc.body.appendChild(el);
      this.content = new Vue({
        store,
        i18n,
        data: { children: Object.freeze(this.$slots.default) },
        render(h) {
          return h('div', this.children);
        }
      });
      this.content.$mount(el);
      if (this.autoHeight) {
        this.content.$el.addEventListener('load', this.resize, true);
        window.addEventListener('resize', this.resize);
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(this.resize);
          this.resizeObserver.observe(this.content.$el);
        }
        this.$nextTick(this.resize);
      }
    },
    resize() {
      if (this.autoHeight && this.content) {
        this.$el.style.height = `${Math.ceil(this.content.$el.getBoundingClientRect().height)}px`;
      }
    },
    cleanup() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.resize);
      if (this.content) {
        this.content.$el.removeEventListener('load', this.resize, true);
        this.content.$destroy();
        this.content.$el.remove();
        this.content = null;
      }
    }
  },
  beforeUpdate() {
    if (this.content) {
      this.content.children = Object.freeze(this.$slots.default);
      this.$nextTick(this.resize);
    }
  },
  beforeDestroy() {
    this.cleanup();
  }
};
</script>
